import { rem } from "polished";

import { withViewportStyle } from "@/components/editor/shared/with-viewport-style";
import StyledButtonContainer from "@/components/editor/themes/nolan/shared/cta-button";

const Wrapper = withViewportStyle("div")`
  display: grid;
  grid-auto-rows: max-content;
  grid-gap: ${rem(16)};
  padding: ${rem(80)} ${rem(140)};

  ${(props) => props.$viewport.tablet`
    padding: ${rem(80)} ${rem(16)};
  `}
  
  ${(props) => props.$viewport.mobile`
    padding: ${rem(40)} ${rem(16)};
  `}
`;

const ImageWrapper = withViewportStyle("div")`
  margin: 0 auto ${rem(24)} auto;

  .image-primitive {
    max-width: ${rem(600)};
    width: 100%;
  }

  ${(props) => props.$viewport.tablet`
    margin-bottom: ${rem(8)};

    .image-primitive {
      max-width: 100%;
    }
  `};
`;

const ButtonWrapper = withViewportStyle(StyledButtonContainer)`
  text-align: center;
  margin-top: ${rem(8)};

  ${(props) => props.$viewport.tablet`
    margin-top: 0;
  `};
`;

export { Wrapper, ImageWrapper, ButtonWrapper };
